import { diffWords, diffChars, Change } from 'diff';
import {
  backgroundColors,
  textColors,
} from '@teetsh/app/src/styles/themeConstants';

function stripHtml(html: string): string {
  const temp = document.createElement('div');
  temp.innerHTML = html;
  return temp.textContent || temp.innerText || '';
}

function getTextNodes(node: Node): Text[] {
  const textNodes: Text[] = [];

  function walk(n: Node) {
    if (n.nodeType === Node.TEXT_NODE) {
      const text = n.textContent || '';
      if (text.trim()) {
        textNodes.push(n as Text);
      }
    } else {
      n.childNodes.forEach(child => walk(child));
    }
  }

  walk(node);
  return textNodes;
}

// 100% vibe yolo coded...
export function createHtmlDiff(
  originalHtml: string,
  newHtml: string,
  mode: 'words' | 'chars' = 'words',
): string {
  const originalText = stripHtml(originalHtml);
  const newText = stripHtml(newHtml);

  const diff: Change[] =
    mode === 'chars'
      ? diffChars(originalText, newText)
      : diffWords(originalText, newText);

  // Parse the new HTML to preserve structure
  const container = document.createElement('div');
  container.innerHTML = newHtml;

  const textNodes = getTextNodes(container);

  // Track position in the diff
  let diffIndex = 0;
  let diffOffset = 0; // Offset within current diff part

  // Process each text node
  textNodes.forEach(textNode => {
    const nodeText = textNode.textContent || '';
    const fragment = document.createDocumentFragment();
    let nodeOffset = 0;

    while (diffIndex < diff.length) {
      const part = diff[diffIndex];
      const partRemaining = part.value.length - diffOffset;
      const nodeRemaining = nodeText.length - nodeOffset;

      // Handle removed parts (they're not in new HTML, but we want to show them)
      if (part.removed) {
        // Add removed text inline
        const span = document.createElement('span');
        span.style.backgroundColor = backgroundColors['danger-moderate'];
        span.style.color = textColors['danger-intense'];
        span.style.textDecoration = 'line-through';
        span.textContent = part.value.substring(diffOffset);
        fragment.appendChild(span);

        diffOffset = 0;
        diffIndex++;
        continue;
      }

      // Break if we've processed all text in this node
      if (nodeOffset >= nodeText.length) {
        break;
      }

      // How much of this part can we consume from this node?
      const consumeLength = Math.min(partRemaining, nodeRemaining);
      const chunk = nodeText.substring(nodeOffset, nodeOffset + consumeLength);

      if (part.added) {
        const span = document.createElement('span');
        span.style.backgroundColor = backgroundColors['positive-moderate'];
        span.style.color = textColors['positive-intense'];
        span.textContent = chunk;
        fragment.appendChild(span);
      } else {
        fragment.appendChild(document.createTextNode(chunk));
      }

      nodeOffset += consumeLength;
      diffOffset += consumeLength;

      // Move to next diff part if we consumed it all
      if (diffOffset >= part.value.length) {
        diffOffset = 0;
        diffIndex++;
      }
    }

    // Replace the text node with our highlighted version
    textNode.parentNode?.replaceChild(fragment, textNode);
  });

  return container.innerHTML;
}
